import { render, staticRenderFns } from "./unmatched-shops-view.vue?vue&type=template&id=5474d3b3&scoped=true"
import script from "./unmatched-shops-view.vue?vue&type=script&lang=js"
export * from "./unmatched-shops-view.vue?vue&type=script&lang=js"
import style0 from "./unmatched-shops-view.vue?vue&type=style&index=0&id=5474d3b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474d3b3",
  null
  
)

export default component.exports